import { keymirror } from 'app/blocks/common/utils';

const SigningMethodEnum = keymirror({
    ELECTRONIC: '',
    PRINT: '',
});

export default SigningMethodEnum;
